/**
 * Detect bot messages that commit to handing the conversation to a human agent.
 * Mirrors backend IdealBotResponseEnforcer.isHandoverResponse().
 */
const HANDOVER_PHRASES = [
  'passing this to the team',
  'passing you to the team',
  'looping the team in',
  'flagging this to the team',
  'handing this over',
  'hand this over to',
];

export function isBotHandoverMessage(content?: string | null): boolean {
  const text = (content || '').toLowerCase();
  return HANDOVER_PHRASES.some((phrase) => text.includes(phrase));
}
